export default __webpack_public_path__ + "static/media/b10.dffc0006.webp";